import { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import Navigation from "@/components/Navigation";
import { Footer } from "@/components/Footer";

const Rodo = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Obowiązek informacyjny RODO - WystepKomediowy.pl</title>
        <meta name="description" content="Obowiązek informacyjny RODO serwisu WystepKomediowy.pl. Informacje o przetwarzaniu danych osobowych." />
        <link rel="canonical" href="https://wystepkomediowy.pl/rodo" />
        <meta property="og:title" content="Obowiązek informacyjny RODO - WystepKomediowy.pl" />
        <meta property="og:description" content="Obowiązek informacyjny RODO serwisu WystepKomediowy.pl." />
        <meta property="og:url" content="https://wystepkomediowy.pl/rodo" />
      </Helmet>
      <Navigation />
      <main className="pt-32 pb-20">
        <div className="container max-w-3xl mx-auto px-4">
          <h1 className="text-3xl md:text-4xl font-montserrat font-bold text-primary mb-8">
            Obowiązek informacyjny <span className="gradient-text">RODO</span>
          </h1>

          <div className="prose prose-gray max-w-none space-y-6 text-gray-600 leading-relaxed">
            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">1. Administrator danych osobowych</h2>
              <p>Administratorem Twoich danych osobowych jest Wirtualny Biznes, ul. Księcia Witolda 49/15, 50-202 Wrocław, NIP: 8961619199 (dalej: "Administrator").</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">2. Cel przetwarzania danych</h2>
              <p>Twoje dane osobowe przetwarzane są w celu:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Realizacji zapytań przesłanych za pośrednictwem formularza kontaktowego</li>
                <li>Przygotowania i realizacji oferty występów komediowych</li>
                <li>Kontaktu telefonicznego lub mailowego w związku z zapytaniem</li>
                <li>Wypełnienia obowiązków prawnych ciążących na Administratorze</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">3. Podstawa prawna przetwarzania</h2>
              <p>Dane przetwarzane są na podstawie:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Art. 6 ust. 1 lit. a RODO - zgoda osoby, której dane dotyczą</li>
                <li>Art. 6 ust. 1 lit. b RODO - wykonanie umowy lub podjęcie działań przed jej zawarciem</li>
                <li>Art. 6 ust. 1 lit. f RODO - prawnie uzasadniony interes Administratora</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">4. Okres przechowywania danych</h2>
              <p>Dane osobowe będą przechowywane przez okres niezbędny do realizacji celów, dla których zostały zebrane, a po tym czasie przez okres wymagany przepisami prawa lub do momentu wycofania zgody.</p>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">5. Prawa osoby, której dane dotyczą</h2>
              <p>Przysługuje Ci prawo do:</p>
              <ul className="list-disc pl-6 space-y-1 mt-2">
                <li>Dostępu do swoich danych osobowych</li>
                <li>Sprostowania danych</li>
                <li>Usunięcia danych ("prawo do bycia zapomnianym")</li>
                <li>Ograniczenia przetwarzania</li>
                <li>Przenoszenia danych</li>
                <li>Wniesienia sprzeciwu wobec przetwarzania</li>
                <li>Cofnięcia zgody w dowolnym momencie</li>
                <li>Wniesienia skargi do Prezesa Urzędu Ochrony Danych Osobowych</li>
              </ul>
            </section>

            <section>
              <h2 className="text-xl font-montserrat font-bold text-primary mt-8 mb-3">6. Kontakt</h2>
              <p>W sprawach związanych z ochroną danych osobowych prosimy o kontakt na adres e-mail: <a href="mailto:kontakt@wystepkomediowy.pl" className="text-brand-purple hover:underline">kontakt@wystepkomediowy.pl</a></p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Rodo;
